<template>
  <div>
    <!--更换空间-->
    <el-row>
      <img src="../../assets/images/index/roomIcon.png"
           style="margin-left: 1.3vw;margin-top: 10px;float: left;margin-right: 5px;">
      <div style="line-height: 40px;">
        <span style="color: rgba(7, 230, 248, 1)">{{ currentSpaceInfo.title }}</span>
        <a @touchstart="spaceTreeDisable = !spaceTreeDisable" @click="spaceTreeDisable = !spaceTreeDisable" class="pointer text-white" style="margin-left: 10px;">更换空间</a>
      </div>
      <space-tree-show :space-id="currentSpaceInfo.id ? currentSpaceInfo.id : null"
                       @close="spaceTreeDisable = false"
                       @spaceChoose="spaceClick"
                       class="spaceTree"
                       ref="spaceTree"
                       v-show="spaceTreeDisable"></space-tree-show>
    </el-row>

    <div style="position: absolute;right: 22px;top: 55px;z-index: 9">
      <div @touchstart="showDialog" @click="showDialog" class="listIcon pointer">
        <img src="../../assets/images/comprehensive/plus.png">
      </div>
    </div>

    <div style="width: 100%;height: 90vh;position: relative;" v-if="deviceCustomLayouts.length > 0">
      <vue-draggable-resizable
        :debug="false"
        :h="item.paramsData.position.height"
        :isConflictCheck="true"
        :isDraggable="true"
        :isResizable="false"
        :key="item.id"
        :min-height="200"
        :min-width="200"
        :parent="true"
        :snap="true"
        :snapTolerance="1"
        :w="item.paramsData.position.width"
        :x="item.paramsData.position.left"
        :y="item.paramsData.position.top"
        @dragstop="(x,y) => {return dragStop(x,y,item)}"
        @refLineParams="getRefLineParams"
        @resizestop="(x,y,width,height) => {return resizeStop(x,y,width,height,item)}"
        v-for="item in deviceCustomLayouts">
        <clouded-glass class="main">
          <div slot="content" style="height: 100%">
            <!--测点值展示-->
            <point-view-drag :layoutData="item"
                             :showButton="true"
                             ref="pointViewDrag"
                             v-if="item.component === 'pointViewDrag' && item.paramsData.formData.length > 0"></point-view-drag>
            <!--内景图-->
            <indoor-setting :space-id="currentSpaceInfo.id" indoorType="list" style="padding: 20px 10px 0 10px;"
                            v-if="item.component === 'indoor'"/>
            <!--实验室情况-->
            <space-device-total :current-space-info="currentSpaceInfo"
                                v-if="item.component === 'deviceTotal'"></space-device-total>
          </div>
        </clouded-glass>

      </vue-draggable-resizable>


      <!--辅助线-->
      <span :key="item.id"
            :style="{ left: item.position, top: item.origin, height: item.lineLength}"
            class="ref-line v-line"
            v-for="item in vLine"
            v-show="item.display"
      />
      <span :key="item.id"
            :style="{ top: item.position, left: item.origin, width: item.lineLength}"
            class="ref-line h-line"
            v-for="item in hLine"
            v-show="item.display"
      />
      <!--辅助线END-->
    </div>


    <dialog-component
      :dialogVisible.sync="dialogVisible"
      @dialogClose="dialogClose"
      dialog-title="添加模板"
      width="55%">
      <div class="dialog-padding" slot="content">
        <add-template :currentSpaceInfo="currentSpaceInfo" :dialogFlush="dialogFlush"
                      @getPointViewData="getPointViewData"></add-template>
      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center;margin-bottom: 15px;">
        <el-button @touchstart="dialogClose" @click="dialogClose" size="mini">关 闭</el-button>
        <el-button @touchstart="preservation" @click="preservation" size="mini" type="primary">保 存</el-button>
      </div>
    </dialog-component>

  </div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable-gorkys'
import 'vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css'
import pointViewDrag from "@/views/overview/dialogContent/pointViewDrag";
import SpaceDeviceTotal from "@/views/overview/dialogContent/SpaceDeviceTotal";
import CloudedGlass from "@/components/style/CloudedGlass";
import IndoorSetting from "@/components/indoor_setting/IndoorSetting";
import {getCustomPage, savePage} from "@/network/device-custom-page";
import DialogComponent from "@/components/DialogComponent";
import {saveOrUpdateCustomLayout} from "@/network/device-custom-layout";
import AddTemplate from "@/views/overview/dialogContent/AddTemplate";
import SpaceTreeShow from "@/components/space/SpaceTreeShow";

export default {
  name: "ConfigurationListEdit",
  components: {
    VueDraggableResizable, pointViewDrag, SpaceDeviceTotal, CloudedGlass, IndoorSetting, DialogComponent,
    AddTemplate, SpaceTreeShow
  },
  data() {
    return {
      winWidth: 0,
      winHeight: 0,
      deviceCustomLayouts: [],
      formData: [],
      dialogFlush: false,
      dialogVisible: false,
      spaceTreeDisable: false,
      page: 'configurationList',
      currentSpaceInfo: [],
      vLine: [],
      hLine: []
    }
  },
  watch: {
    dialogVisible: {
      handler(newV) {
        if (newV) {
          this.dialogFlush = false
        } else {
          this.dialogFlush = true
        }
      },
    },
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getPointData:5000': this.getPointData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getPointData')
  },
  mounted() {
    this.winWidth = window.innerWidth;
    this.winHeight = window.innerHeight;
    window.onresize = () => {
      return (() => {
        this.winWidth = window.innerWidth;
        this.winHeight = window.innerHeight;
      })();
    };
  },
  methods: {
    // 辅助线回调事件
    getRefLineParams(params) {
      const {vLine, hLine} = params
      let id = 0
      this.vLine = vLine.map(item => {
        item['id'] = ++id
        return item
      })
      this.hLine = hLine.map(item => {
        item['id'] = ++id
        return item
      })
    },
    //更换按钮
    spaceClick(data, init) {
      const currentSpaceInfo = this.$cookies.get("currentSpaceInfo")
      if (currentSpaceInfo && init) {
        this.currentSpaceInfo = currentSpaceInfo
      } else {
        this.currentSpaceInfo = data
        this.$cookies.set("currentSpaceInfo", JSON.stringify(data))
      }
      this.spaceTreeDisable = false;
      this.getCustomPageInfo();
    },
    showDialog() {
      this.dialogVisible = true
    },
    dialogClose() {
      this.dialogVisible = false;
    },
    //获取表单数据
    getPointViewData(data) {
      this.formData = data
    },
    //获取自定义页面信息
    //获取组态列表自定义页面(没有则保存)
    getCustomPageInfo() {
      getCustomPage(this.page).then(res => {
        if (res.code === 0) {
          if (res.data === null) {
            let deviceCustomPageDto = {
              deviceCustomPage: {page: this.page, name: '组态列表'},
              deviceCustomLayouts: [{
                name: 'common',
                component: 'indoor',
                params: JSON.stringify({position: {left: 20, top: 0, width: 350, height: 290}}),
              }, {
                name: 'common',
                component: 'deviceTotal',
                params: JSON.stringify({position: {left: 20, top: 310, width: 350, height: 115}}),
              }]
            };
            savePage(deviceCustomPageDto).then(() => {
              this.getCustomPageInfo();
            })
          } else {
            this.deviceCustomPage = res.data.deviceCustomPage;
            if (res.data.deviceCustomLayouts.length > 0) {
              this.deviceCustomLayouts = res.data.deviceCustomLayouts
                .filter(item => item.name === this.currentSpaceInfo.id || item.name === 'common')
                .map(item => {
                  item.paramsData = JSON.parse(item.params);
                  return item;
                })
            }
          }
        }
      })
    },
    getPointData() {
      this.$refs.pointViewDrag.forEach(item => {
        item.getPointValues()
      })
    },
    //停止放大缩小
    resizeStop(x, y, width, height, item) {
      item.paramsData.position.left = x;
      item.paramsData.position.top = y;
      item.paramsData.position.width = width;
      item.paramsData.position.height = height;
      item.params = JSON.stringify(item.paramsData);
      this.saveData(item)
    },
    //停止拖拽
    dragStop(x, y, item) {
      item.paramsData.position.left = x;
      item.paramsData.position.top = y;
      item.params = JSON.stringify(item.paramsData);
      this.saveData(item)
    },
    preservation() {
      if (this.formData.length > 0) {
        if (this.formData[0].layout === 1) {
          //曲线合并指标
          const formData = this.formData[0]
          const pointList = formData.pointList.filter(item => item.pointId)
          if (!this.$stringIsNotNullAndEmpty(formData.name)) {
            this.$message.error("名称不能为空!")
          } else if (pointList.length !== formData.pointList.length) {
            this.$message.error("请选择测点!")
          } else {
            this.saveData();
          }
        } else {
          //曲线跟随指标
          let flag = 0
          this.formData.forEach(item => {
            const name = item.pointList.filter(item => item.name.trim() !== "")
            const pointList = item.pointList.filter(item => item.pointId)
            if (name.length !== item.pointList.length) {
              this.$message.error("名称不能为空!")
            } else if (pointList.length !== item.pointList.length) {
              this.$message.error("请选择测点!")
            } else {
              flag = flag + 1;
            }
          })
          if (flag && flag === this.formData.length) {
            this.saveData();
          }
        }
      } else {
        this.$message.error("数据不能为空!")
        return 0;
      }
    },
    //保存数据
    saveData(dragData) {
      let params = {}
      if (dragData) {
        params = dragData;
      } else {
        let data = {
          position: {
            width: 350,
            height: 425,
            top: 0,
            left: 390,
          },
          formData: this.formData
        }
        params = {
          name: this.currentSpaceInfo.id,
          pageId: this.deviceCustomPage.id,
          component: 'pointViewDrag',
          params: JSON.stringify(data),
        }
      }
      saveOrUpdateCustomLayout(params).then(res => {
        if (res.code === 0) {
          this.dialogVisible = false;
          this.getCustomPageInfo();
        }
      })
    },
    destroyed() {
      window.onresize = null
    }
  }
}
</script>

<style scoped>

.spaceTree {
  display: inline-block;
  position: absolute;
  min-height: 60vh;
  max-height: 870px;
  z-index: 999;
  background-color: rgba(0, 62, 119, .9);
  width: 380px;
  padding: 10px 15px 20px 10px;
}

.listIcon {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: rgba(41, 155, 255, .2);
  text-align: center;
  line-height: 30px;
}

.main {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  padding-bottom: 10px;
}

</style>
